import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
    Box, Button,
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
    CircularProgress, Typography, Paper, Avatar,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import {
    useRecordContext,
} from 'react-admin';

const Profile = (props) => {

    const record = useRecordContext(props)
    let size = 40

    return (
        <Box>
            <Typography
                variant="body2"
                display="flex"
                flexWrap="nowrap"
                alignItems="center"
                component="div"
                sx={props.sx}
            >
                <Avatar
                    sx={{ mr: 1 }}
                    src={`${record.profile}`}
                    style={{ width: parseInt(size, 10), height: parseInt(size, 10) }}
                    alt={`${record.email} ${record.name}`}
                />
                <Box display="block">
                    {record.email}
                    {record.name}
                </Box>

            </Typography>
        </Box>
    )
};


export default Profile;